const messages = {
  flight: {
    leg: {
      id: 'flight.leg',
      defaultMessage:
        '{airlineName} {flightNumber}{operatedByAirlineName, select, true {*} false {}}',
    },
    operatedBy: {
      id: 'flight.operatedBy',
      defaultMessage:
        '{showAsterisk, select, true {*} false{} }{flightNumbers} operated by {airlineName}',
    },
    title: {
      id: 'flight.title',
      defaultMessage: '{departureCityName} to {arrivalCityName}',
    },
    travelTimes: {
      id: 'flight.traveltime',
      defaultMessage:
        '{departureTime} - {arrivalTime} {overnight, select, true {({overnightLabel})} false {}}',
    },
    startLabelText: {
      id: 'flight.startLabelText',
      defaultMessage: 'Depart',
    },
    locationText: {
      id: 'flight.locationText',
      defaultMessage: '{cityCode} ({cityName})',
    },
    endLabelText: {
      id: 'flight.endLabelText',
      defaultMessage: 'Arrive',
    },
    passengers: {
      id: 'flight.passengers.label',
      defaultMessage:
        '{numberOfPassengers, number} {numberOfPassengers, plural, one {passenger} other {passengers}}',
    },
    rate: {
      title: {
        id: 'flight.rate.title',
        defaultMessage: 'Fare',
      },
      select: {
        id: 'flight.rate.select',
        defaultMessage: 'Select a fare',
      },
      label: {
        id: 'flight.rate.label',
        defaultMessage:
          // tslint:disable-next-line:max-line-length
          '{optionText} {showPrice, select, true { • {price}} false {}} {recommended, select, true {(Recommended)} false {}}',
      },
    },
    direct: {
      id: 'flight.direct',
      defaultMessage: 'Direct',
    },
    multipleStop: {
      id: 'flight.multipleStops',
      defaultMessage: '{stops} {stops, plural, one {stop} other {stops}}',
    },
    arrivalInfo: {
      nextDay: {
        label: {
          id: 'arrival.nextDay.label',
          defaultMessage: '+1',
        },
      },
      twoDaysLater: {
        label: { id: 'arrival.twoDaysLater.label', defaultMessage: '+2' },
      },
      previousDay: {
        label: { id: 'arrival.previousDay.label', defaultMessage: '-1' },
      },
    },
  },
  hotel: {
    roomAndNights: {
      id: 'hotel.roomAndNights',
      defaultMessage: '{rooms}, {nights}',
    },
    rooms: {
      id: 'hotel.rooms',
      defaultMessage:
        '{numberOfRooms, number} {numberOfRooms, plural, one {room} other {rooms}}',
    },
    nights: {
      id: 'hotel.nights',
      defaultMessage:
        '{numberOfNights, number} {numberOfNights, plural, one {night} other {nights}}',
    },
    title: {
      id: 'hotel.title',
      defaultMessage: 'Stay in {cityName}',
    },
    startLabelText: {
      id: 'hotel.startLabelText',
      defaultMessage: 'Check in',
    },
    endLabelText: {
      id: 'hotel.endLabelText',
      defaultMessage: 'Check out',
    },
    distanceInKm: {
      id: 'hotel.distanceInKm',
      defaultMessage: '{distanceInKm}km from {location}',
    },
    distanceInKmForSaviSelectIntl: {
      id: 'hotel.distanceInKm.for.savi.select.intl',
      defaultMessage: '{distanceInKm} km',
    },
    rate: {
      title: {
        id: 'hotel.rate.title',
        defaultMessage: 'Room',
      },
      select: {
        id: 'hotel.rate.select',
        defaultMessage: 'Select a room',
      },
      label: {
        id: 'hotel.rate.label',
        defaultMessage:
          // tslint:disable-next-line:max-line-length
          '{optionText} {showPrice, select, true { • {price}} false {}} {recommended, select, true { (Recommended)} false {}}',
      },
    },
    disclaimer: {
      id: 'hotel.disclaimer',
      defaultMessage:
        'This price is converted to show you the approximate cost in your local currency. The exchange rate might change before you pay. Keep in mind that your card issuer may charge you a foreign transaction fee. ',
    },
  },
  car: {
    days: {
      id: 'car.days',
      defaultMessage: '{days, number} {days, plural, one {day} other {days}}',
    },
    title: {
      id: 'car.title',
      defaultMessage: 'Rental car in {cityName}',
    },
    allocation: {
      id: 'car.allocation',
      defaultMessage: '{count} {count, plural, one {vehicle} other {vehicles}}',
    },
    startLabelText: {
      id: 'car.startLabelText',
      defaultMessage: 'Pick up',
    },
    endLabelText: {
      id: 'car.endLabelText',
      defaultMessage: 'Drop off',
    },
    locationText: {
      id: 'car.locationText',
      defaultMessage: `{address, select,
          undefined {}
          other {{address}{cityName, select,
            undefined {}
            other {, }
          }}}{cityName, select,
          undefined {}
          other {{cityName}}}`,
    },
    rate: {
      title: {
        id: 'car.rate.title',
        defaultMessage: 'Vehicle',
      },
      select: {
        id: 'car.rate.select',
        defaultMessage: 'Select a vehicle',
      },
      label: {
        id: 'car.rate.label',
        defaultMessage:
          // tslint:disable-next-line:max-line-length
          '{optionText} {showPrice, select, true { • {price}} false {}} {recommended, select, true {(Recommended)} false {}}',
      },
    },
  },
  options: {
    id: 'options',
    defaultMessage:
      'View {numberOfOptions, number} {numberOfOptions, plural, one {option} other {options}}',
  },
  travellerInfo: {
    travellers: {
      id: 'travellerInfo.travellers',
      defaultMessage:
        '{travellers, number} {travellers, plural, one {traveller} other {travellers}}',
    },
  },
  segmentContent: {
    optionOf: {
      id: 'segmentContent.optionOf',
      defaultMessage: 'Option {index} of {optionCount}',
    },
    needMoreOptions: {
      title: {
        id: 'segmentContent.needMoreOptions.title',
        defaultMessage: 'Need more options?',
      },
      body: {
        id: 'segmentContent.needMoreOptions.body',
        defaultMessage:
          'Email your arranger to request changes to this itinerary.',
      },
    },
    currentlySelected: {
      id: 'segmentContent.currentlySelected',
      defaultMessage: 'This is currently selected',
    },
    duration: {
      id: 'segmentContent.duration',
      defaultMessage: 'Duration',
    },
    allocation: {
      id: 'segmentContent.allocation',
      defaultMessage: 'Allocation',
    },
  },
  common: {
    loading: {
      id: 'common.loading',
      defaultMessage: 'Loading itinerary...',
    },
    requestChanges: {
      id: 'common.requestChanges',
      defaultMessage: 'Request changes',
    },
    select: {
      id: 'common.select',
      defaultMessage: 'Select',
    },
    selected: {
      id: 'common.selected',
      defaultMessage: 'Selected',
    },
    next: {
      id: 'common.next',
      defaultMessage: 'Next',
    },
    changesRequested: {
      id: 'common.changesRequested',
      defaultMessage: 'Changes requested',
    },
    tripTo: {
      id: 'common.tripTo',
      defaultMessage: 'Trip to {location}',
    },
    itineraryOptions: {
      id: 'common.itineraryOptions',
      defaultMessage: 'Itinerary options',
    },
    save: {
      id: 'common.save',
      defaultMessage: 'Save',
    },
    cancel: {
      id: 'common.cancel',
      defaultMessage: 'cancel',
    },
    notesFromArranger: {
      id: 'common.notesFromArranger',
      defaultMessage: 'Notes from {arrangerName}: ',
    },
    errorOccurred: {
      id: 'common.errorOccured',
      defaultMessage: 'An error occurred, please try again.',
    },
    reviewCount: {
      id: 'common.reviewCount',
      defaultMessage:
        '({reviewCount, number} {reviewCount, plural, one {review} other {reviews}})',
    },
  },
  notification: {
    trip: {
      sendToArranger: {
        id: 'notification.tripTo.sendToArranger',
        defaultMessage:
          'Your selected itinerary has been sent to your arranger, who will complete the booking for you.',
      },
      changesRequested: {
        id: 'notification.tripTo.changesRequested',
        defaultMessage:
          'Your arranger will contact you with new itinerary options based on your comments.',
      },
      info: {
        id: 'notification.tripTo.info',
        defaultMessage:
          'Please review and select your preferred options or request changes.',
      },
      disclaimer: {
        id: 'notification.tripTo.disclaimer',
        defaultMessage:
          'Prices may change based on availability and are not final until you complete the reservation.',
      },
    },
    messageHelperText: {
      id: 'notification.message.helper.text',
      defaultMessage:
        'This message will be included in the email to your arranger.',
    },
    info: {
      title: {
        id: 'notification.info.title',
        defaultMessage: 'What happens next?',
      },
      bullet1: {
        id: 'notification.info.bullet1',
        defaultMessage:
          'An email will be sent to your arranger with your selected options.',
      },
      bullet2: {
        id: 'notification.info.bullet2',
        defaultMessage: 'Your arranger will complete this booking for you.',
      },
      bullet3: {
        id: 'notification.info.bullet3',
        defaultMessage:
          'Reservations are not confirmed and prices are subject to change.',
      },
    },
  },
  linkExpired: {
    title: {
      id: 'linkExpired.title',
      defaultMessage: 'This link has expired',
    },
    description: {
      id: 'linkExpired.description',
      defaultMessage:
        'For further assistance, please contact the person who shared this link with you.',
    },
  },
};

export default messages;
